// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Rmbgd","storeIcon":"Header_storeIcon__b8YHu","storeInfo":"Header_storeInfo__MouiN","onlineShop":"Header_onlineShop__ohkkP"};